<script setup lang="ts">
import { PerfectScrollbar } from 'vue3-perfect-scrollbar'

import { useAuthStore } from '@/stores/auth'
import { useEntityStore } from '@/stores/entity'
import { useUserStore } from '@/stores/user'

import { buildUserProfileList } from './userProfileMenu'

const auth = useAuthStore()
const user = useUserStore()
const entity = useEntityStore()

const userProfileList = computed(() => buildUserProfileList({
  hasMultipleProviders: user.hasMultipleProviders,
  onLogout: auth.logout,
}))

function updateNavbarElement() {
  const navbarElement = document.querySelector('.navbar-chosen-name')

  if (!navbarElement)
    return

  clearNavbarElement()
}

function clearNavbarElement() {
  const navbarElement = document.querySelector('.navbar-chosen-name')
  if (navbarElement)
    navbarElement.innerHTML = ''
}

watchEffect(() => {
  if (entity.data?.uuid)
    updateNavbarElement()
})
</script>

<template>
  <div class="navbar-chosen-name font-weight-bold mr-4 mb-0" />
  <VAvatar
    class="cursor-pointer"
    color="primary"
    variant="text"
  >
    <VIcon icon="mdi-account-outline" />
    <VMenu
      activator="parent"
      width="230"
      location="bottom end"
      z-index="3000"
      offset="14px"
    >
      <VList density="comfortable">
        <!-- 👉 User Avatar & Name -->
        <VListItem height="60px">
          <template #prepend>
            <VListItemAction start>
              <VAvatar
                class="cursor-pointer"
                color="primary"
                variant="tonal"
              >
                <VIcon icon="mdi-account-outline" />
              </VAvatar>
            </VListItemAction>
          </template>

          <VListItemTitle class="text-primary font-weight-bold">
            {{ user.data.name }}
          </VListItemTitle>
          <VListItemSubtitle>
            {{ user.data.email }}
          </VListItemSubtitle>
        </VListItem>

        <VDivider />
        <PerfectScrollbar :options="{ wheelPropagation: false }">
          <template
            v-for="item in userProfileList"
            :key="item.title"
          >
            <VListItem
              v-if="item.type === 'navItem' && !!item.to"
              :to="item.to"
            >
              <template #prepend>
                <VIcon
                  class="me-2"
                  :icon="item.icon"
                  size="22"
                />
              </template>

              <VListItemTitle>{{ item.title }}</VListItemTitle>
            </VListItem>
            <VListItem
              v-else-if="item.type === 'navItem' && !!item.href"
              :href="item.href"
              target="_blank"
              rel="noopener noreferrer"
            >
              <template #prepend>
                <VIcon
                  class="me-2"
                  :icon="item.icon"
                  size="22"
                />
              </template>

              <VListItemTitle>{{ item.title }}</VListItemTitle>
            </VListItem>
            <VListItem
              v-else-if="item.type === 'navItem' && item.onClick"
              @click="item.onClick"
            >
              <template #prepend>
                <VIcon
                  class="me-2"
                  :icon="item.icon"
                  size="22"
                />
              </template>

              <VListItemTitle>{{ item.title }}</VListItemTitle>
            </VListItem>

            <VDivider v-else />
          </template>
        </PerfectScrollbar>
      </VList>
    </VMenu>
  </VAvatar>
</template>
